<template>
  <v-dialog v-model="open" max-width="80%" scrollable @click:outside="hide">
    <v-card>
			<v-card-title class="title primary--text secondary">
        <translate>TCM Test</translate><span class="mx-1">-</span><translate>Pulse</translate>
				<template v-if="results"><span class="mx-1">-</span><translate>Results</translate></template>
      </v-card-title>
			<v-card-text class="pt-4">
        <v-form ref="form">
					<TCMPulseDiagram :test="test" :results="results" :edit="edit" :types="types" ref="pulseDiagram" />
					<v-btn v-if="results" icon @click="showNotes = !showNotes">
						<v-icon v-if="!showNotes" color="primary lighten-1">mdi-chevron-down</v-icon>
						<v-icon v-else color="primary lighten-1">mdi-chevron-up</v-icon>
					</v-btn>
					<v-row v-if="!results || showNotes" no-gutters>
						<v-textarea
							v-model="test.data.note"
							class="px-2"
							:label="$gettext('Notes')"
							filled
							dense
							no-resize
							:disabled="results"
							placeholder="..."
							hide-details
						/>
					</v-row>
					<template v-if="results">
						<p class="mt-4 text-subtitle-1 font-weight-medium" v-translate>Diagnosis</p>
						<v-row no-gutters class="mb-3">
							<p v-if="test.result.results.length == 0" class="font-weight-thin ml-2 text-body-2 grey--text" v-translate>No results.</p>
							<v-col v-else v-for="result in test.result.results" cols="6" :key="result.id">
								<v-row no-gutters align="center">
									<v-col cols="12">
										<span class="mx-1 font-weight-bold" v-for="(pointType, i) in result.point_types" :key="i">
											{{pointType.point.name}} - {{pointType.type.name}}
										</span>
									</v-col>
									<v-col v-if="result.note" cols="12">
										<span class="mx-1">{{result.note}}</span>
									</v-col>
									<v-col cols="12">
										<v-row no-gutters align="center" class="ml-2">
											<ICDList context="test-results" :list="result.icds" />
										</v-row>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</v-form>
			</v-card-text>
      <v-divider></v-divider>
			<v-card-actions>
				<v-btn v-if="results" color="primary darken-1" text @click="hide">
					<translate>Close</translate>
				</v-btn>
				<v-btn v-else color="primary darken-1" text @click="hide">
					<translate>Cancel</translate>
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn v-if="!edit && !results" color="primary darken-1" text @click="submitTest">
					<translate>Create</translate>
				</v-btn>
				<v-btn v-if="edit" color="primary darken-1" text @click="editTest">
					<translate>Save</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import ICDList from "@/components/icd/ICDList.vue";
import TCMPulseDiagram from '@/components/appointment/tests/tcm/TCMPulseDiagram.vue';

export default {
  name: "TCMPulseForm",
  props: {
		test: {
			default: () => ({
				kind: "pulse",
        module: "tcm",
        data: {
          note: null,
					chiR: {
						note: "",
						types: []
					},
					chiL: {
						note: "",
						types: []
					},
					guanR: {
						note: "",
						types: []
					},
					guanL: {
						note: "",
						types: []
					},
					tsunR: {
						note: "",
						types: []
					},
					tsunL: {
						note: "",
						types: []
					},
					allR: {
						types: []
					},
					allL: {
						types: []
					}
        }
			})
		},
		edit: {
			default: false
		},
		results: {
			default: false
		}
  },
	components: {
		ICDList,
		TCMPulseDiagram
	},
  data: () => ({
		showNotes: false,
    open: true,
		types: []
  }),
  methods: {
    validateForm() {
      return this.$refs.form.validate();
    },
		getForm() {
			return this.$refs.pulseDiagram.getForm();
		},
    submitTest() {
      if(this.validateForm()) {
				const form = this.getForm();
        this.$emit("create-test", form);
        this.hide();
      }
		},
		editTest() {
      if(this.validateForm()) {
        const form = this.getForm();
        this.$emit("edit-test", form);
        this.hide();
      }
		},
		hide() {
			this.$emit("hide");
		}
	},
	created() {
		axios
			.get("/pulse_types")
			.then(response => {
				console.log(response.data);
				this.types = response.data.pulse_types;
			})
			.catch(error => {
				console.log(error);
			});
	}
}
</script>